@if (itemsFiltered.length > 2) {
  <div class="flex mb-3">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-20rem"
        pInputText
        #searchQuery
        (keyup)="updateList(searchQuery.value)"
        placeholder="durchsuchen ..." />
    </p-iconField>
  </div>
}
<p-accordion *ngIf="itemsFiltered.length" [activeIndex]="0">
  @for (item of itemsFiltered; track item.key) {
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex gap-3">
          <i *ngIf="icon" [class]="icon"></i>
          <span>{{ item.importName }}</span>
          <span class="kbd absolute top-0 right-0 m-0">{{ item.key }}</span>
        </div>
      </ng-template>

      @if (item.errorKeys.length) {
        <app-alert severity="error" [canToggle]="false" styleClass="p-2"
          >Überprüfen Sie Ihre Zahlen. Fehler in <b>Rot</b> markiert!</app-alert
        >
      }
      <app-data-table
        [data]="item"
        [errorKeys]="item.errorKeys"
        [errorValues]="item.errorValues"
        [warningKeys]="item.warningKeys"
        [districts]="precomputedDistricts[item.key]"></app-data-table>
    </p-accordionTab>
  }
</p-accordion>
